
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../reducers';

export function useVenueDataLayer() {
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const venues = useSelector((state: IReduxAppState) => state.venue);
    const venueData = useSelector((state: IReduxAppState) => state.venue[venueId]?.venueData);
    const venueLoc = useSelector((state: IReduxAppState) => state.venue[venueId]?.venueLocation);
    const venueSettings = useSelector((state: IReduxAppState) => state.venue[venueId]?.venueSettings);
    const venueTypes = useSelector((state: IReduxAppState) => state.venueTypes);
    const feePlans = useSelector((state: IReduxAppState) => state.feePlans);
    const merchant = useSelector((state: IReduxAppState) => state.merchant);
    const { doneTasks, totalTasks } = useSelector((state: IReduxAppState) => state.outstanding);

    useEffect(() => {
        if (!venueId || !venueData || !venueLoc || !totalTasks) return;
        setDataLayer();
        //eslint-disable-next-line
    }, [venueId, venueData, venueLoc, doneTasks, totalTasks]);

    function setDataLayer() {
        const venueType = venueTypes ? venueTypes.find((obj: any) => obj.id === venueData?.venue_type_id) : {};
        const feePlan = feePlans ? feePlans.find((obj: any) => obj.id === venueData?.processing_fees_plans_id) : {};
        const dataLayerObj = {
            venueName: venueData?.venue_name,
            venueNickname: venueData?.venue_nickname ?? "not-set",
            venueCountry: venueLoc?.address_country,
            venueSource: venueData?.onboarding_source,
            completedOnboarding: !!(doneTasks === totalTasks) ? "Yes" : "No",
            amountOfVenues: Object.keys(venues).length,
            venueType: venueType?.internal_name ?? "not-set",
            subscriptionPlan: feePlan?.name_public ?? "not-set",
            ...venueSettings, 
            ...venueLoc, 
            ...venueData,
            ...merchant
        }

        TagManager.dataLayer({
            dataLayer: dataLayerObj
        })
    }
    return { setDataLayer }
}